import {styled, mq} from '../../../utils';
import {borderWidth, position} from 'polished';

export default styled('div')(({theme}) => {
  return {
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all .15s ease-in',
    boxSizing: 'border-box',
    borderRadius: '50%',
    background: theme.color.primary,
    color: '#fff',
    width: 50,
    height: 50,
    fontFamily: theme.fontFamily.base,
    fontSize: 16,
    fontWeight: 700,
    [mq('laptopAndUp')]: {
      width: 60,
      height: 60
    },
    // space between
    '::before': {
      content: `''`,
      borderRadius: '50%',
      borderStyle: 'solid',
      borderColor: '#fff',
      borderWidth: 5,
      [mq('laptopAndUp')]: {
        borderWidth: 7.5
      },
      ...position('absolute', 1)
    },
    // space around
    '::after': {
      content: `''`,
      borderRadius: '50%',
      borderStyle: 'solid',
      borderColor: '#fff',
      ...borderWidth(10, 0),
      ...position('absolute', -10, 0)
    }
  };
});



// WEBPACK FOOTER //
// ./src/containers/RegistrationWizard/private/RegistrationWizardCurrentStepHead.tsx